@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  height: 100%;
  border-radius: 10px;
  background: var(--light-100);
  position: relative;

  @include card-shadow;
}

.planHeader {
  display: flex;
  padding: 20px;
  justify-content: space-between;
  gap: 10px;
  align-self: stretch;
  align-items: center;
  border-radius: 10px 10px 0 0;

  &.compact {
    padding: 10px;
    border-radius: 10px;
  }

  &.blaze_creator {
    background: linear-gradient(180deg, #34f403 0%, #026d40 100%);
  }

  &.blaze_pro {
    background: linear-gradient(180deg, #c26dff 0%, #5400ca 100%);
  }

  &.blaze_team {
    background: linear-gradient(0deg, #e8099c 0%, #f9f 100%);
  }

  &.blaze_agency {
    background: linear-gradient(180deg, #4edfff 0%, #0064dc 100%);
  }
}

.planIconTitle {
  display: flex;
  align-items: center;
  gap: 5px;
  color: var(--light-100);
}

.actionContainer {
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}

.planFeatures {
  display: flex;
  padding: 0px 20px 20px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  align-self: stretch;
}

.specialBadge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--yellow-50);
  color: var(--dark-80);
  font-family: Sohne;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 139%; /* 13.9px */
  letter-spacing: 0.2px;
  text-transform: uppercase;
  padding: 2px 11px 3px 11px;
  border-radius: 21px;
  z-index: 1;
  white-space: nowrap;
  @include card-shadow;
}

.crossedOut {
  position: relative;
  margin-right: 4px;
  color: var(--dark-40);

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    opacity: 1;
    right: 0;
    height: 1px;
    background-color: var(--dark-100);
    transform: rotate(-45deg);
  }
}

.boldOff {
  font-weight: 700;
}
